import axios from 'axios';
import React, { useState, useEffect } from 'react';
import configData from '../../config.json';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDataContext } from '../../context/data';
import translations from '../../constants/translations.json';
import { Modal } from '../../components/ui/Modal';

const inputClassName =
  'w-full py-3 px-4 text-sm bg-[#f5f5f5] border border-transparent rounded-[10px] outline-none text-[#333] transition-[border-color] duration-200 focus:border-primary';

const labelClassName =
  'text-[11px] font-semibold text-[#555] uppercase tracking-[0.5px] mb-1.5 block';

const ChangePasswordModal = (props) => {
  const { open, toggle, setpasswordmodal, userProfile } = props;
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [loading, setLoading] = useState(false);

  const [data, setdata] = useState({
    currentpassword: '',
    newpassword: '',
    confirmpassword: '',
  });

  const { language } = useDataContext();

  useEffect(() => {
    if (!open) {
      setdata({ currentpassword: '', newpassword: '', confirmpassword: '' });
      setShowPasswords({ current: false, new: false, confirm: false });
    }
  }, [open]);

  const handleChange = (key, value) => {
    setdata({ ...data, [key]: value });
  };

  const updatePasswordNow = async (e) => {
    try {
      e.preventDefault();
      if (data.newpassword !== data.confirmpassword) {
        toast.error(
          translations[language]?.profile_change_password_mismatch ||
            'Kodeord stemmer ikke overens',
        );
        return;
      }

      setLoading(true);
      await axios({
        method: 'PUT',
        url: `${configData.SERVER_URL}/user/password/change`,
        data: {
          password: data.currentpassword,
          newpassword: data.newpassword,
        },
        headers: {
          Authorization: `Bearer ${userProfile.token}`,
        },
      });

      toast.success(
        translations[language]?.profile_change_password_success || 'Kodeord er opdateret',
      );
      toggle();
    } catch (ex) {
      const message =
        ex?.response?.data?.Message ||
        translations[language]?.profile_change_password_error ||
        'Kunne ikke ændre kodeord.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const PasswordField = ({ id, label, value, field, showKey }) => (
    <div>
      <label className={labelClassName}>{label}</label>
      <div className="relative">
        <input
          id={id}
          type={showPasswords[showKey] ? 'text' : 'password'}
          className={`${inputClassName} pr-11`}
          value={value}
          onChange={(e) => handleChange(field, e.target.value)}
          required
          autoComplete={showKey === 'current' ? 'current-password' : 'new-password'}
        />
        <button
          type="button"
          onClick={() => setShowPasswords((p) => ({ ...p, [showKey]: !p[showKey] }))}
          className="absolute right-3 top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer text-gray-400 text-sm"
        >
          <i className={`fas fa-eye${showPasswords[showKey] ? '-slash' : ''}`} />
        </button>
      </div>
    </div>
  );

  return (
    <Modal isOpen={open} onClose={toggle} contentClassName="max-w-[420px]">
      <div className="pt-8 px-6 pb-6">
        <div className="text-center mb-6">
          <div
            className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_4px_16px_rgba(99,102,241,0.3)]"
            style={{ background: 'linear-gradient(135deg, #96c11f, #6f9800)' }}
          >
            <span className="text-3xl">🔒</span>
          </div>
          <h3 className="text-xl font-bold text-[#1a1a1a] mb-1">
            {translations[language]?.profile_change_password}
          </h3>
        </div>

        <form onSubmit={updatePasswordNow} className="flex flex-col gap-3.5">
          <PasswordField
            id="current_password"
            label={translations[language]?.profile_change_password_current}
            value={data.currentpassword}
            field="currentpassword"
            showKey="current"
          />
          <PasswordField
            id="new_password"
            label={translations[language]?.profile_change_password_new}
            value={data.newpassword}
            field="newpassword"
            showKey="new"
          />
          <PasswordField
            id="confirm_password"
            label={translations[language]?.profile_change_password_new_confirm}
            value={data.confirmpassword}
            field="confirmpassword"
            showKey="confirm"
          />

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-[14px] text-[15px] font-semibold bg-primary hover:bg-secondary text-white border-none rounded-xl transition-colors duration-200 mt-2 flex items-center justify-center gap-2 ${
              loading ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'
            }`}
          >
            {loading && <i className="fas fa-spinner fa-spin" />}
            {translations[language]?.profile_change_password}
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
